class t{constructor(t,s){this._components=t,this._data=s}get components(){return this._components}get data(){return this._data}}export{t as AnimData};
